import { GameCategory } from '../enums'
import { T } from './translation-keys'

export const GameCategoryNames = {
  [GameCategory.BOG]: T.BOG,
  [GameCategory.Arcade]: T.ARCADE,
  [GameCategory.BetOnLottery]: T.BET_ON_GAMES,
  [GameCategory.SportFan]: T.SPORT_FAN,
  [GameCategory.Slot]: T.SLOT,
  [GameCategory.TableGames]: T.TABLE_GAMES,
  [GameCategory.BetShop]: T.BETSHOP,
  [GameCategory.VirtualGames]: T.VIRTUAL_GAMES,
  [GameCategory.CryptoGames]: T.CRYPTO_GAMES,
  [GameCategory.Bonus]: T.BONUS,
  [GameCategory.Instant]: T.INSTANT,
  [GameCategory.TronixZone]: T.TRONIX,
  [GameCategory.VirtualSports]: T.VIRTUAL_SPORTS,
  [GameCategory.Predictor]: T.PREDICTOR,
  [GameCategory.NumberGames]: T.NUMBER_GAMES,
}